
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { DataService } from "src/app/shared/constants/data.service";
import { ValidationsComponent } from "src/app/shared/validations/validations.component";
import { enumFormModes } from "../../common/common-enums";
import { GenericService } from "../../services/base/generic-service";
import { GenericEntryFormFunctions } from "./generic-entry-form-functions";


export class GenericEntryForm<T, S> extends GenericEntryFormFunctions<T, S> {
    showValidationArr = new Array();
    title: string = '';
    btnText: any = 'Ok';
    selectedTabIndex = 0;
       
    constructor(public agenericRepository: GenericService<T>, router: Router, public dialog: MatDialog) {
        super(agenericRepository, router);

    }

    // For Form Mode -- New & Edit
    // Request is ANY, Response is T
    async PopulateEntryForm() {

        let aUrl: string = "";
        let aRequestData: any;
        if (this.getFormMode == enumFormModes.ModeNew) {
            aUrl = this.getURLForFormModeNew;
            aRequestData = this.getRequestDataForFormModeNew;
            this.btnText = 'Language.AddText';
        }
        else if (this.getFormMode == enumFormModes.ModeEdit) {
            aUrl = this.getURLForFormModeEdit;
            aRequestData = this.getRequestDataForFormModeEdit;
            // this.btnText = 'Language.OkText';
            this.btnText = 'Language.UpdateText';
        }

        if (aUrl.trim().length > 0) {
            return await this.PopulateGenericEntryForm(aUrl, aRequestData);
        }
        else return null;

    }

    // For Form Mode -- Add & Update
    // Request is T, Response is ANY
    SaveEntryForm(): void {

        let aUrl: string = "";
        let aRequestData: any;
        if (this.getFormMode == enumFormModes.ModeNew) {
            aUrl = this.getURLForFormModeAddSap;
            aRequestData = this.getEntryFormDataSourceSAP;
            if (aUrl.trim().length > 0) {
                this.AddGenericEntryFormSAP(aUrl, aRequestData);
            }
            aUrl = this.getURLForFormModeAdd;
            aRequestData = this.getEntryFormDataSource;
        }
        else if (this.getFormMode == enumFormModes.ModeEdit) {
            aUrl = this.getURLForFormModeUpdateSap;

            //   if(this.router.routerState.snapshot.url.includes('salesDownPaymentRequestEntryForm')){

            //      let getData:any=this.getEntryFormDataSourceSAP;

            //         aRequestData ={
            //             Comments:getData?.Comments?getData?.Comments:''
            //         };


            //  }
            //  else{

            aRequestData = this.getEntryFormDataSourceSAP;

            //  }
            if (aUrl.trim().length > 0) {

                (async () => {

                    await this.UpdateGenericEntryFormSAP(aUrl, aRequestData);
                    this.btnText = 'Language.OkText';
                })()
            }
            aUrl = this.getURLForFormModeUpdate;
            aRequestData = this.getEntryFormDataSource;
        }

        if (aUrl.trim().length > 0) {
            this.SaveGenericEntryForm(aUrl, aRequestData);
        }

    }

    openDialog() {
        let filterDialogRef = this.dialog.open(ValidationsComponent, {
            // height: '100%',
            width: '400px',
            panelClass: 'validatesection',
            position: { right: 0 + 'px', top: 56 + 'px' },
            data: {
                showValidation: this.showValidationArr,
                title: this.title
            }
        });
        filterDialogRef.afterClosed().subscribe((res: any) => {

        });
    }


    btnEvent(event: any) {
        if (this.getFormMode == 1) {
            this.btnText = 'Language.UpdateText';
        }
    }

    onTabChange(event: any) {
        this.selectedTabIndex = event.index;
    }

    navigateTab(count: number) {
        this.selectedTabIndex += count;
    }

}
